export default class MoveCustomerOnAnotherAccountRequest {
    public customerId: number | null = null;

    public email: string | null = null;
}